// tslint:disable-next-line: typedef variable-name
export const TestClass = {
    faqPage: {
        faqDeleteButton: "faqPageFaqDeleteButton",
    },
};
